import { render, staticRenderFns } from "./PlainComponents.vue?vue&type=template&id=3087abb5&"
import script from "./PlainComponents.vue?vue&type=script&lang=js&"
export * from "./PlainComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QImg,QList,QItem,QItemSection,QItemLabel,QCard,QBadge,QCardSection,QInput,QBtn,QTooltip,QField,QCheckbox,QSelect,QFile,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QImg,QList,QItem,QItemSection,QItemLabel,QCard,QBadge,QCardSection,QInput,QBtn,QTooltip,QField,QCheckbox,QSelect,QFile,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
